import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

import { ERole } from "../../../../../@types";
import { useAccount } from "../../../../../hooks/useAccount";
import { useMyServices } from "../../../../../hooks/useMyServices";
import { useProfile } from "../../../../../hooks/useProfile";
import { useStripe } from "../../../../../hooks/useStripe";

export function ToDoList() {
	const { profile } = useProfile();
	const { courses } = useMyServices();
	const { account } = useAccount();
	const { stripeData } = useStripe();

	const isProfileOk = profile && profile.introduction !== "";
	const isServicesOk = account?.role !== ERole.INSTRUCTOR || courses.length > 0;
	const isFinishedStripe =
		!account?.requiredKYC && stripeData?.status === "ACTIVE";
	const isStripeOk = account?.role !== ERole.INSTRUCTOR || isFinishedStripe;

	if (isProfileOk && isServicesOk && isFinishedStripe) {
		return null;
	}

	return (
		<>
			<div className="section-separator-with-line" />
			<Typography className="small-title-text bold">To-Do List</Typography>
			{!isProfileOk && (
				<Typography className="normal-text item-separator-small">
					Create your Profile{" "}
					<Link to="/about-me/profile" className="normal-link">
						here
					</Link>
				</Typography>
			)}
			{!isServicesOk && (
				<Typography className="normal-text item-separator-small">
					Add Services{" "}
					<Link to="/training/my-services" className="normal-link">
						here
					</Link>
				</Typography>
			)}
			{!isStripeOk && (
				<Typography className="normal-text item-separator-small">
					Set up Stripe{" "}
					<Link to="/stripe" className="normal-link">
						here
					</Link>
				</Typography>
			)}
		</>
	);
}
